import { addDoc, serverTimestamp } from 'firebase/firestore';
import { auditLogCol } from '@/lib/firestore/refs';
import type { PrincipalRef } from '@shared/types';

/** Appends an auditLog row; failures are logged, never thrown, so the user action itself still completes. */
export async function logAudit(
  by: PrincipalRef,
  action: string,
  resource: { type: string; id: string } | null,
  extra: { before?: unknown; after?: unknown; meta?: Record<string, unknown> } = {},
): Promise<void> {
  try {
    await addDoc(auditLogCol(), { at: serverTimestamp(), by, action, resource, before: extra.before ?? null, after: extra.after ?? null, meta: extra.meta ?? {} } as never);
  } catch (e) {
    console.warn('audit write failed', e);
  }
}
